import {useContext, useEffect, useRef} from 'react';

import {
  EventCallBackFuncType,
  KeyboardShortcutsContext,
  KeyboardShortcutsContextType,
} from './KeyboardShortcutsProvider';

export function useKeyboardShortcuts(): KeyboardShortcutsContextType {
  const localShortcuts = useRef<Array<string>>([]);
  const context = useContext(KeyboardShortcutsContext);

  const enableShortcut = (key: string, callback: EventCallBackFuncType) => {
    localShortcuts.current.push(key);
    return context.enableShortcut(key, callback);
  };

  useEffect(() => {
    return () => {
      // on unmount disable local shortcuts
      localShortcuts.current.forEach(context.disableShortcut);
    };
  });
  return {...context, enableShortcut};
}

export {cats} from './KeyboardShortcutsProvider';
